
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { Home, Search, ArrowLeft, Zap } from 'lucide-react';

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="max-w-lg w-full text-center">
        {/* Animated Icon */}
        <div className="relative mb-8">
          <div className="w-32 h-32 mx-auto bg-primary rounded-full flex items-center justify-center shadow-2xl animate-pulse">
            <Zap className="w-16 h-16 text-primary-foreground" />
          </div>
          <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-32 h-32 bg-primary/20 rounded-full -z-10 animate-ping opacity-20"></div>
        </div>

        {/* Error Content */}
        <div className="space-y-6">
          <div>
            <h1 className="text-8xl font-bold text-primary mb-4">
              404
            </h1>
            <h2 className="text-3xl font-bold text-foreground mb-2">
              Page not found
            </h2>
            <p className="text-lg text-muted-foreground mb-8">
              Oops! The page you're looking for seems to have disappeared into the energy maze.
            </p>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => navigate("/user/dashboard")}
              className="inline-flex items-center justify-center space-x-2 bg-primary text-primary-foreground px-6 py-3 rounded-lg font-medium hover:opacity-90 transition-all duration-200 transform hover:scale-105 shadow-lg"
            >
              <Home size={20} />
              <span>Back to home</span>
            </button>

            <button
              onClick={() => navigate("/login")}
              className="inline-flex items-center justify-center space-x-2 bg-card text-card-foreground px-6 py-3 rounded-lg font-medium border border-border hover:bg-muted transition-all duration-200 transform hover:scale-105 shadow-lg"
            >
              <ArrowLeft size={20} />
              <span>Login</span>
            </button>
          </div>

          {/* Search Suggestion */}
          <div className="mt-8 p-6 bg-card rounded-2xl shadow-lg border border-border">
            <div className="flex items-center justify-center space-x-3 mb-4">
              <Search className="w-6 h-6 text-primary" />
              <h3 className="text-lg font-semibold text-foreground">
                Perhaps you were looking for...
              </h3>
            </div>

            <div className="grid grid-cols-2 gap-3 text-sm">
              <button onClick={() => navigate("/user/dashboard")} className="text-primary hover:opacity-80 hover:underline transition-colors text-left">
                • Dashboard
              </button>
              <button onClick={() => navigate("/user/bills")} className="text-primary hover:opacity-80 hover:underline transition-colors text-left">
                • Bills
              </button>
              <button onClick={() => navigate("/user/meter")} className="text-primary hover:opacity-80 hover:underline transition-colors text-left">
                • Meter
              </button>
              <button onClick={() => navigate("/user/topup")} className="text-primary hover:opacity-80 hover:underline transition-colors text-left">
                • Top-up
              </button>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-12 text-sm text-muted-foreground">
          <p>Error code: 404 | Page: {location.pathname}</p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
